import { createContext, useState, useContext } from "react";

// ✅ Create Context
const SliderContext = createContext();

// ✅ Provide Global State
export const SliderProvider = ({ children }) => {
  const [isSliderOpen, setIsSliderOpen] = useState(false);

  return (
    <SliderContext.Provider value={{ isSliderOpen, setIsSliderOpen }}>
      {children}
    </SliderContext.Provider>
  );
};

// ✅ Custom Hook for Using Context
export const useSlider = () => useContext(SliderContext);
